/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Input_LabelInputs */

const en_rd_input_label = /** @type {(inputs: Rd_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public GitHub repository`)
};

const id_rd_input_label = /** @type {(inputs: Rd_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repo GitHub publik`)
};

/**
* | output |
* | --- |
* | "Public GitHub repository" |
*
* @param {Rd_Input_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_input_label = /** @type {((inputs?: Rd_Input_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Input_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_input_label(inputs)
	return en_rd_input_label(inputs)
});